import React from "react";
import { Link } from "gatsby";

import { ISnippet, ICustomData, IBasicText, IBasicMedia } from "../../../../interfaces";
import { COMPONENTS } from "../../../../constants";
import WhereToBuyForm, { getLocalInfo } from "../../../utils/where-to-buy-form";
import { LocalInfo, FormValProps, State } from "../../../utils/where-to-buy-form/interfaces";

import { setStorage, getStorage } from "../../../../localStorage.service";
import CmsMarkdown from "../../../basic/cms-markdown";
import { guid, applyTransformations } from "../../../../utils";

const FORM_STATE_LOCAL_DETAILS = "localDetails";
const FORM_STATE_GET_QUOTE = "getQuote";

type FormState = "localDetails" | "getQuote";

const LOCAL_STORAGE_KEY = "localInfo";
const BACKGROUND_IMAGE_NAME = "Strapi_ComponentBasicMedia";

class WhereToBuyFooter extends React.Component<ISnippet, State> {
  snippet: ISnippet;
  snippetData: ICustomData;
  formContentLayouts: object = {};
  backgroundImage: IBasicMedia;
  defaultFormStateValues: FormValProps = {
    btnHover: "",
    btnText: "",
    btnType: "",
    content: null,
    href: ""
  };

  constructor(props) {
    super(props);
    this.snippet = this.props;
    this.state = {
      zipcode: undefined,
      country: undefined,
      formStateVals: {
        ...this.defaultFormStateValues
      },
      localInfo: null,
      loading: false,
      error: false
    };

    this.snippetData = (this.snippet?.data?.attributes?.layout || []).find((item) => {
      return item.__typename === COMPONENTS.CUSTOM_DATA;
    }) as ICustomData;

    this.backgroundImage = (this.snippet?.data?.attributes?.layout || []).find((item) => {
      return item.__typename === COMPONENTS.SNIPPET_MEDIA;
    }) as IBasicMedia;

    (this.snippet?.data?.attributes?.layout || []).forEach((item) => {
      if (item.__typename != COMPONENTS.CUSTOM_DATA) {
        this.formContentLayouts[item.name] = item;
      }
    });

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
  }

  handleError(error) {
    this.setState({ loading: false, error: true });
    console.warn("handleError", error);
  }

  async handleSubmit(event) {
    event && event.preventDefault();
    this.setState({ loading: true, error: false });
    let localInfo;
    try {
      localInfo = await getLocalInfo(this.state.zipcode, this.state.country);
      if (this.isEmptyObject(localInfo) || localInfo === null) {
        this.handleError("No local info found");
      } else {
        this.setState({ localInfo: localInfo, loading: false });
        this.setFormState(FORM_STATE_GET_QUOTE);
      }
      this.forceUpdate();
    } catch (e) {
      this.setState({ loading: false, error: true });
    }
  }

  handleZipcodeChange(event) {
    this.setState({ zipcode: event.target.value });
  }

  handleCountryChange(event) {
    this.setState({ country: event.target.value });
  }

  isEmptyObject(object: object) {
    return JSON.stringify(object) === JSON.stringify({});
  }

  setFormState(state: FormState) {
    const { content = "", ...otherProps } = this.snippetData?.data
      ? this.snippetData?.data[state]
      : {};

    this.setState({
      formStateVals: {
        ...otherProps,
        content: this.formContentLayouts[content]
      }
    });
  }

  changeLocation() {
    this.setState({
      formStateVals: {
        ...this.defaultFormStateValues
      },
      localInfo: null
    });
    this.setFormState(FORM_STATE_LOCAL_DETAILS);
    setStorage(LOCAL_STORAGE_KEY, {});
  }

  renderUrlParams() {
    let params = new URL(document.location).searchParams;
    let query_zipcode = params.get("postal-code");
    let query_country = params.get("country");

    if (query_zipcode) {
      if (query_country) {
        this.setState({ country: query_country });
      }
      this.setState({ zipcode: query_zipcode, loading: true }, () => {
        this.changeLocation();
        this.handleSubmit();
      });
    }
  }

  async componentDidMount() {
    const cachedLocalInfo = getStorage(LOCAL_STORAGE_KEY);
    this.renderUrlParams();

    if (this.isEmptyObject(cachedLocalInfo)) {
      this.setFormState(FORM_STATE_LOCAL_DETAILS);
    } else {
      this.setState({ localInfo: cachedLocalInfo });
      this.setFormState(FORM_STATE_GET_QUOTE);
    }
  }

  render() {
    const { btnHover, btnText, btnType, content, href } = this.state.formStateVals;
    return (
      <div
        id="where-to-buy"
        className="background-image-cover py-7 md-h3-thin md-hr-center-white"
        style={{
          backgroundImage: `url(${applyTransformations(
            this.backgroundImage?.media?.data?.attributes?.url,
            {
              w: 1700
            }
          )})`
        }}
      >
        <div className="container-md p-responsive where-to-buy-footer">
          {!this.state.localInfo && (
            <div>
              {content == null ? null : (
                <CmsMarkdown key={guid()} content={content} elementClasses={{ p: "f3" }} />
              )}
              {this.state.error && <div className="error">{this.state.error}</div>}
              <WhereToBuyForm
                buttonText={btnText}
                onSubmit={this.handleSubmit}
                onZipcodeChange={this.handleZipcodeChange}
                onCountryChange={this.handleCountryChange}
                loading={this.state.loading}
                error={this.state.error}
                className={`set-${btnType} set-${btnHover} flex-justify-center`}
              />
            </div>
          )}
          {this.state.localInfo && (
            <div>
              <CmsMarkdown
                key={guid()}
                content={content}
                bindValues={this.state.localInfo}
                className="clearfix"
              />
              <div className="text-center mt-4 mb-3 mx-auto">
                <Link to={href} className="btn btn-quote d-inline-block">
                  {btnText}
                </Link>
              </div>
              <p className="text-center text-italic">
                Postal Code: {this.state.localInfo.zipcode}{" "}
                <button className="btn-link text-underline" onClick={this.changeLocation}>
                  (Change Location)
                </button>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default WhereToBuyFooter;
